import { NotificationModel, SupplierNotificationModel } from '../../../api/admin/admin.types';
import { Action } from 'redux';
import { Page } from '../../../api/api.types';

export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const GET_NOTIFICATIONS_LIST = 'GET_NOTIFICATIONS_LIST';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const POST_NOTIFICATION = 'POST_NOTIFICATION';
export const PUT_NOTIFICATION = 'PUT_NOTIFICATION';

export interface NotificationState {
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalPages: number;
  totalElements: number;
  notifications: NotificationModel[] | [];
  selectedNotification: NotificationModel | null;
  openNotifications: SupplierNotificationModel[] | null;
}

export interface GetNotificationAction extends Action {
  type: typeof GET_NOTIFICATION;
  payload: {
    selectedNotification: NotificationModel | null;
  };
}

export interface GetNotificationsListAction extends Action {
  type: typeof GET_NOTIFICATIONS_LIST;
  payload: {
    page: Page<NotificationModel>;
  };
}

export interface PostNotificationAction extends Action {
  type: typeof POST_NOTIFICATION;
  payload: {
    selectedNotification: NotificationModel;
  };
}

export interface PutNotificationAction extends Action {
  type: typeof PUT_NOTIFICATION;
  payload: {
    selectedNotification: NotificationModel;
  };
}

export interface DeleteNotificationAction extends Action {
  type: typeof DELETE_NOTIFICATION;
  payload: {
    selectedNotification: null;
  }
}

export type NotificationActionTypes =
  GetNotificationAction |
  GetNotificationsListAction |
  PostNotificationAction |
  PutNotificationAction;